import React, {memo} from 'react';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from 'common/names';
import {ISFTPActivityReportParameters} from 'types/diplomat/reports/SFTPActivityReportParameters';

import {useDownloadPostApi} from 'common/hooks/useDownloadPostApi';
import api from 'api';
import {SFTPActivityReportForm} from './SFTPActivityReportForm';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {enums} from 'types/enums';

type Props = {
   onClose: () => void;
};
export const SFTPConnectionsReportDialog = memo(({onClose}: Props) => {
   const {download} = useDownloadPostApi();
   const sendParameters = React.useCallback(
      (
         values: ISFTPActivityReportParameters,
         bag: FormOnSubmitHelpers<ISFTPActivityReportParameters>
      ) => {
         const url =
            values._format === enums.reportFormats.enum.CSV
               ? api.sftpConnectionsReport + 'csv'
               : api.sftpConnectionsReport;
         download(url, JSON.stringify(values), {
            onSuccess: () => bag.setSubmitting(false),
            onFailure: (errors: any) => {
               bag.setSubmitting(false);
               bag.setErrors(errors);
            },
         });
      },
      [download]
   );

   return (
      <DialogComponent
         maxWidth="lg"
         header={DialogTypes.SFTPConnectionsReportDialog.dialogName}
         close={onClose}
      >
         <SFTPActivityReportForm onClose={onClose} onSubmit={sendParameters} />
      </DialogComponent>
   );
});
